import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        readOne(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/channels/${id}`)
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
    },
};
